// ---------------------------------------------------------------------------
// Voice delivery cues in the chat transcript. The voice model takes expressive
// tags such as [Warmly], [laughs] or [excited] in Lenny's text to shape how he
// sounds, and they were showing in the chat panel as literal text (Robbie,
// 2026-10-19: hide the cues).
//
// stripVoiceCues() removes a square-bracketed run of words, nothing else:
//   - kept: markdown links "[Oat milk](https://...)" (handled by linkify),
//           numbered references "[1]", and anything containing digits or other
//           symbols
// ---------------------------------------------------------------------------

// Letters, spaces, hyphens and apostrophes only (up to 42 characters), not followed by "(".
const CUE_RE = /\[[A-Za-z][A-Za-z' -]{0,40}\](?!\()[ \t]*/g;

export function stripVoiceCues(text) {
  if (!text || text.indexOf('[') === -1) return text;
  return text
    .replace(CUE_RE, '')
    .replace(/[ \t]{2,}/g, ' ')
    .replace(/[ \t]+\n/g, '\n')
    .trim();
}
